// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-form-wrapper {
    width: 100%;
    margin: 20px 0;
}

.registration-form {
    width: 100%;
    display: flex;
    align-items: end;
}

.register-input-field {
    width: 250px;
    display: flex;
    flex-direction: column;
    margin-right: 10px;
}

.registration-form label {
    font-weight: 700;
    font-size: 19px;
    margin-bottom: 5px;
}

.registration-form input {
    cursor: text;
}

.registration-form input,
.registration-form select {
    padding: 8px;
    height: 40px;
    border: 1px solid var(--psblue);
}

.registration-form input:focus,
.registration-form select:focus {
    outline: none;
    outline: 1px solid var(--psblue)
}

.registration-form button {
    width: 250px;
    height: 40px;
    background: var(--psblue);
    color: white;
    border: none;
    cursor: pointer;
}

.registration-form button:hover {
    background: var(--psblue-accent)
}

.registration-form button:active {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/table/addNewUser.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,+BAA+B;AACnC;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;AAC1C","sourcesContent":[".registration-form-wrapper {\n    width: 100%;\n    margin: 20px 0;\n}\n\n.registration-form {\n    width: 100%;\n    display: flex;\n    align-items: end;\n}\n\n.register-input-field {\n    width: 250px;\n    display: flex;\n    flex-direction: column;\n    margin-right: 10px;\n}\n\n.registration-form label {\n    font-weight: 700;\n    font-size: 19px;\n    margin-bottom: 5px;\n}\n\n.registration-form input {\n    cursor: text;\n}\n\n.registration-form input,\n.registration-form select {\n    padding: 8px;\n    height: 40px;\n    border: 1px solid var(--psblue);\n}\n\n.registration-form input:focus,\n.registration-form select:focus {\n    outline: none;\n    outline: 1px solid var(--psblue)\n}\n\n.registration-form button {\n    width: 250px;\n    height: 40px;\n    background: var(--psblue);\n    color: white;\n    border: none;\n    cursor: pointer;\n}\n\n.registration-form button:hover {\n    background: var(--psblue-accent)\n}\n\n.registration-form button:active {\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
